<template>
  <v-dialog v-model="dialog" width="700" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon>person</v-icon> Gestionar Cuenta
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0" v-if="!!form.personas">
          <v-container grid-list-md class="pt-0">
            <v-layout row wrap align-space-around>
              <v-flex xs12>
                <span class="blue--text title">Datos de usuario</span>
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    color="primary"
                    icon
                    outline
                    small
                    @click="actualizarDatosUsuario(form.id)"
                  >
                    <v-icon size="medium">refresh</v-icon>
                  </v-btn>
                  <span>Actualizar datos</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs12 md6>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    v-for="(atributo, index) in atributos_usuario"
                    :key="index"
                    class="datos-usuario"
                  >
                    <div class="titulo">{{ atributo.label }}</div>
                    <div class="contenido">{{ atributo.value }}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6 class="text-xs-center ">
                <v-card class="elevation-1" style="height: 100%;">
                  <v-layout row wrap align-space-around justify-center>
                    <v-flex xs12 class="datos-usuario">
                      <v-avatar
                        :color="foto ? '#FFF' : 'light-blue darken-4'"
                        size="120"
                      >
                        <v-img
                          v-if="foto"
                          :aspect-ratio="16 / 9"
                          :src="foto"
                          max-height="150"
                          max-width="150"
                          min-height="120"
                          min-width="120"
                          @error="handleImageError()"
                        >
                        </v-img>
                        <span v-else class="white--text display-1">{{
                          form.personas[0].nombres.trim()[0] || "-"
                        }}</span>
                      </v-avatar>
                    </v-flex>
                    <hr />
                    <v-divider></v-divider>
                    <v-flex xs12>
                      <span class="blue--text"><b>ESTADO CUENTA</b></span
                      ><br />
                      <v-chip :color="form.bloqueo ? 'red' : 'success'" dark>{{
                        form.bloqueo ? "BLOQUEADO" : "ACTIVO"
                      }}</v-chip>
                    </v-flex>
                    <v-flex shrink>
                      <v-switch
                        class="text-field-reducido"
                        v-model="form.bloqueo"
                        color="indigo"
                        :label="form.bloqueo ? 'Desbloquear?' : 'Bloquear?'"
                        @change="resetearNroIntentosHabilitar()"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12>
                      <v-expansion-panel>
                        <v-expansion-panel-content class="expand-pass">
                          <template v-slot:header>
                            <div>RESTABLECER CONTRASEÑA</div>
                          </template>
                          <v-card class="px-3 py-2">
                            <v-card-text>
                              <v-text-field
                                class="text-field-reducido-border"
                                name="password"
                                :label="$t('login.password')"
                                id="password"
                                :append-icon="getIcon"
                                @click:append="changeIcon"
                                :type="hidePass ? 'password' : 'text'"
                                v-model="form_reset.password"
                                maxlength="100"
                                :rules="$validate(['required'])"
                                required
                                outline
                              ></v-text-field>
                            </v-card-text>
                            <v-card-actions class="pa-0">
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="loading"
                                ><v-icon>check</v-icon>
                                {{ $t("common.save") }}</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      form: {},
      api_backend: process.env.API_URL.split("api/")[0],
      foto: null,
      hidePass: true,
      remember: false,
      form_reset: { password: "" }
    };
  },
  computed: {
    getIcon() {
      return this.form_reset.password.length === 0
        ? "lock"
        : this.hidePass
        ? "visibility"
        : "visibility_off";
    },
    atributos_usuario() {
      return Object.keys(this.form).length > 0
        ? [
            {
              label: "Nombre de usuario",
              value: this.form.nombre_usuario
            },
            {
              label: "Nombre completo",
              value: `${this.form.personas[0].ap_paterno} ${this.form.personas[0].ap_materno} ${this.form.personas[0].nombres}`
            },
            {
              label: "Correo",
              value: this.form.correo
            },
            {
              label: "CI",
              value: `${this.form.personas[0].nro_doc} ${this.form.personas[0].nro_complemento}`
            },
            {
              label: "Dependencia",
              value: this.form.dependencia
            },
            {
              label: "Unidad",
              value: this.form.nombre_unidad
            },
            {
              label: "Cargo",
              value: this.form.cargo
            },
            {
              label: "Puesto",
              value: this.form.puesto
            },
            {
              label: "Bloqueado",
              value: this.form.bloqueo ? "SI" : "NO"
            },

            {
              label: "Nro de intentos login",
              value: this.form.nro_intentos
            },
            {
              label: "Fecha ultimo intento login",
              value: this.form.fecha_ultimo_intento
                ? this.$moment(this.form.fecha_ultimo_intento).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )
                : "No se tiene registro"
            },
            {
              label: "Fecha bloqueo",
              value: this.form.fecha_bloqueo
                ? this.$moment(this.form.fecha_bloqueo).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )
                : "No se tiene registro"
            },
            {
              label: "IP ultimo intento login",
              value: this.form.ip_bloqueo
                ? this.form.ip_bloqueo
                : "No se tiene registro"
            }
          ]
        : [];
    }
  },
  mounted() {
    this.$bus.$on("openDialogGestionarCuenta", item => {
      this.form = item;
      this.foto = !!this.form.foto ? this.api_backend + this.form.foto : "";
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para actualizar los datos del usuario
    async actualizarDatosUsuario(id_usuario) {
      let res = await this.$service.graphql({
        query: `
            query{
              vUsuarioGenerals(id:${id_usuario}){
                rows{
                  id
                  nombre_usuario
                  correo
                  id_estado
                  nro_intentos
                  bloqueo
                  fecha_bloqueo
                  ip_bloqueo
                  fecha_ultimo_intento
                  foto
                  nombre_unidad
                  cargo
                  puesto
                  dependencia
                  personas
                  estado
                  roles
                }
              }
            }
          `
      });
      this.form = res.vUsuarioGenerals.rows[0];
    },
    // Metodo para controlar error al cargar img
    handleImageError() {
      this.foto = "";
    },
    //  Metodo para controlar iconos pass
    changeIcon() {
      if (this.form_reset.password.length) {
        this.hidePass = !this.hidePass;
      }
    },
    // Metodo para habilitar o deshabilitar al usuario
    async resetearNroIntentosHabilitar() {
      await this.$query.edit("usuario", parseInt(this.form.id), {
        bloqueo: this.form.bloqueo,
        fecha_bloqueo: this.form.bloqueo ? new Date() : this.form.fecha_bloqueo,
        nro_intentos: this.form.bloqueo ? this.form.nro_intentos : 0
      });
      // Alertamos mensaje de exito
      this.$message.success();
      // ACtualizamos los datos
      await this.actualizarDatosUsuario(this.form.id);
    },
    close() {
      this.dialog = false;
      this.form = {};
      this.values = [];
      this.valid = false;
      this.loading = false;
      this.$bus.$emit("closeDialogGestionarCuenta");
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.form.roles = this.values;
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $usuario: EditUsuario!) {
              usuarioEdit(id: $id, usuario: $usuario) {
                id
              }
            }
          `,
          variables: {
            id: this.id,
            usuario: this.form
          }
        });
        this.$message.success();
        this.loading = false;
        this.$bus.$emit("closeDialogEditUsuarioRoles");
        this.close();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.datos-usuario {
  line-height: 0.85;
  .titulo {
    color: rgb(0, 73, 141);
    font-weight: 600;
  }
}
.expand-pass {
  background: rgb(255, 123, 0) !important;
  color: white !important;
  font-weight: 500 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/usuario/dialogs/GestionarCuenta.vue